import * as React from 'react';
import * as styles from './styles.css';

export const StickyFooter: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div data-testid="StickyFooter" className={styles['container']}>
      {children}
    </div>
  );
};

StickyFooter.displayName = 'StickyFooter';
